import { useGetLinkAccessMoodleQueryPromise } from "../common/api/graphql/queries";
import React from 'react';
export const useOpenMoodleLink = () => {
  const getLinkAccessMoodle = useGetLinkAccessMoodleQueryPromise();
  const openMoodleLink = React.useCallback((target, parameters) => {
    getLinkAccessMoodle({
      redirect_route: target,
      parameters: parameters ? parameters : ''
    }).then(response => {
      if (response.data && response.data.portal_accessMoodle != '') {
        window.open(response.data.portal_accessMoodle, '_self', 'noopener,noreferrer');
      }
    });
  }, []);
  return openMoodleLink;
};